module.exports = __webpack_public_path__ + "media/images/puerta-plegable-7a41a2be153cb5333574975fcd83a3ff.png";